import BaseView from './base';

export default class MatrixTransposeView extends BaseView {
    constructor(matrix) {
        super(matrix, matrix.columns, matrix.rows);
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(columnIndex, rowIndex, value);
        return this;
    }

    get(rowIndex, columnIndex) {
        return this.matrix.get(columnIndex, rowIndex);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-regression-robust-polynomial/~/ml-matrix/src/views/transpose.js
// module id = 227
// module chunks = 0